.errorRoute {
  display: flex;
  align-items: center;
}
